export enum SignUpType {
    /** Create new partial offline profile */
    RAMP,

    /** Complete profile with password */
    ONLINE
}
